/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function() {
  var buyNowButton = document.getElementById("BuyNowButton");
  if (buyNowButton) {
    buyNowButton.addEventListener("click", function() {
      window.location.href = "/checkout";
    });
  }
});

/**
 * MaxVariedad — Social Proof Gatilhos
 * 1. "X personas viendo ahora" — contador próximo ao botão de compra
 * 2. Toast de compra recente — notificação no canto inferior esquerdo
 *
 * Só ativa em páginas de produto (/products/)
 * Para ajustar: edite as constantes na seção CONFIG abaixo
 */

(function () {
  if (!window.location.pathname.includes('/products/')) return;

  /* ─────────────────────────────────────────
     CONFIG — ajuste aqui sem mexer no resto
  ───────────────────────────────────────── */
  var CONFIG = {
    // Viewers counter
    viewersMin: 6,          // mínimo de viewers exibido
    viewersMax: 23,         // máximo de viewers exibido
    viewersUpdateMs: 8000,  // intervalo de atualização do contador (ms)

    // Toast de compra recente
    toastDelayMs: 9000,     // delay do primeiro toast após carregar a página (ms)
    toastIntervalMs: 22000, // intervalo entre toasts (ms)
    toastDurationMs: 5500,  // tempo que o toast fica visível (ms)
  };

  /* ─────────────────────────────────────────
     DADOS — nomes e cidades colombianas
  ───────────────────────────────────────── */
  var NAMES = [
    'María', 'Valentina', 'Camila', 'Laura', 'Andrea',
    'Daniela', 'Sofía', 'Isabella', 'Paola', 'Carolina',
    'Natalia', 'Gabriela', 'Juliana', 'Mariana', 'Sara',
    'Alejandra', 'Fernanda', 'Diana', 'Mónica', 'Ángela'
  ];
  var CITIES = [
    'Bogotá', 'Medellín', 'Cali', 'Barranquilla', 'Cartagena',
    'Bucaramanga', 'Pereira', 'Manizales', 'Cúcuta', 'Ibagué',
    'Santa Marta', 'Pasto', 'Montería', 'Villavicencio', 'Armenia',
    'Neiva', 'Popayán', 'Sincelejo', 'Valledupar', 'Tunja'
  ];
  var TIMES = [
    'hace 2 minutos', 'hace 4 minutos', 'hace 6 minutos',
    'hace 9 minutos', 'hace 12 minutos', 'hace 15 minutos',
    'hace 3 minutos', 'hace 7 minutos', 'hace 11 minutos',
    'hace 18 minutos', 'hace 22 minutos'
  ];

  /* ─────────────────────────────────────────
     UTILITÁRIOS
  ───────────────────────────────────────── */
  function rand(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }
  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /* ─────────────────────────────────────────
     CSS GLOBAL (injetado uma vez)
  ───────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('mv-sp-styles')) return;
    var style = document.createElement('style');
    style.id = 'mv-sp-styles';
    style.textContent = [
      '@keyframes mvSlideIn{from{opacity:0;transform:translateX(-18px)}to{opacity:1;transform:translateX(0)}}',
      '@keyframes mvPulse{0%,100%{opacity:1}50%{opacity:0.5}}',
      '@media(max-width:480px){',
        '#mv-toast{left:10px!important;right:10px!important;max-width:calc(100% - 20px)!important}',
        '#mv-viewers{font-size:12px!important}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  /* ─────────────────────────────────────────
     GATILHO 1 — Viewers counter
  ───────────────────────────────────────── */
  function initViewers() {
    var attempts = 0;
    var interval = setInterval(function () {
      var addBtn = document.querySelector('div._rsi-buy-now-button-app-block-hook');
      attempts++;
      if (addBtn) {
        clearInterval(interval);

        var count = randInt(CONFIG.viewersMin, CONFIG.viewersMax);
        var el = document.createElement('div');
        el.id = 'mv-viewers';
        Object.assign(el.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          color: '#555',
          margin: '10px 0 4px',
          fontFamily: 'sans-serif'
        });
        el.innerHTML =
         '<span style="font-size:13px;" aria-hidden="true">👁️</span>' +
          '<span id="mv-viewers-count" style="font-weight:600;color:#111;">' + count + '</span> <span style="color:#333;">personas están viendo este producto ahora</span>';

        var anchor = document.querySelector('.product__info-container, .product-form, [class*="product-info"]') || addBtn.parentNode;
        var starsEl = document.querySelector('.product-rating, .jdgm-widget, .stamped-badge, [class*="rating"], [class*="review"], [class*="stars"]');
var priceEl = document.querySelector('.price, [class*="price"], .product__price');
var tallaEl = document.querySelector('.product__variants, [class*="variant"], .variant-selects, .product-form__input');
var ref = starsEl || tallaEl || priceEl;
if (ref) {
  ref.parentNode.insertBefore(el, ref.nextSibling);
} else {
  anchor.insertBefore(el, anchor.firstChild);
}

        setInterval(function () {
          var delta = Math.random() > 0.5 ? 1 : -1;
          count = Math.min(CONFIG.viewersMax, Math.max(CONFIG.viewersMin, count + delta));
          var span = document.getElementById('mv-viewers-count');
          if (span) span.textContent = count;
        }, CONFIG.viewersUpdateMs);
      }
      if (attempts > 20) clearInterval(interval);
    }, 500);
  }

  /* ─────────────────────────────────────────
     GATILHO 2 — Toast de compra recente
  ───────────────────────────────────────── */
  function showToast() {
    var existing = document.getElementById('mv-toast');
    if (existing) existing.remove();

    var name = rand(NAMES);
    var city = rand(CITIES);
    var time = rand(TIMES);
    var productName = document.querySelector('h1') ? document.querySelector('h1').textContent.trim().substring(0, 25) : 'este producto';

    var toast = document.createElement('div');
    toast.id = 'mv-toast';
    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '20px',
      left: '20px',
      zIndex: '99999',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      background: '#ffffff',
      border: '1px solid #e5e7eb',
      borderLeft: '4px solid #22c55e',
      borderRadius: '10px',
      padding: '12px 14px',
      maxWidth: '300px',
      boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
      animation: 'mvSlideIn 0.4s ease',
      fontFamily: 'sans-serif',
      cursor: 'default'
    });

    toast.innerHTML =
      '<span style="font-size:20px;flex-shrink:0" aria-hidden="true">🛒</span>' +
      '<div style="flex:1;min-width:0">' +
        '<p style="margin:0;font-size:13px;font-weight:600;color:#111;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + name + ' de ' + city + '</p>' +
        '<p style="margin:2px 0 0;font-size:12px;color:#555">compró ' + productName + '</p>' +
        '<span style="font-size:11px;color:#888">' + time + '</span>' +
      '</div>' +
      '<button aria-label="Cerrar" onclick="this.parentElement.remove()" ' +
        'style="background:none;border:none;cursor:pointer;font-size:18px;color:#bbb;padding:0;line-height:1;flex-shrink:0">×</button>';

    document.body.appendChild(toast);

    setTimeout(function () {
      if (toast.parentElement) toast.remove();
    }, CONFIG.toastDurationMs);
  }

  function initToasts() {
    setTimeout(function () {
      showToast();
      setInterval(showToast, CONFIG.toastIntervalMs);
    }, CONFIG.toastDelayMs);
  }

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */
  function init() {
    injectStyles();
    initViewers();
    initToasts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
